export const DESK_IMAGES = [
  'cms/Employees_Fany_d5be3f0821', // Fany
  'cms/Employees_Pjotr_11650693c9', // Pjotr
  'cms/Employees_Charlotte_280d94d7d4' // Charlotte
]
